




























































import { Component, Prop, Vue } from "vue-property-decorator";
import { PTOPolicy } from "@/dto/payroll/policies/PTOPolicyDTO";
import { PTOPolicyFilter } from "@/dto/payroll/policies/PTOPolicyDTO";
import { processError } from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import RouteNames from "@/router/RouteNames";
import { prettyEnum } from "@/utils/StringUtils";
import PTOPolicyCard from "@/components/payroll/policies/pto/PTOPolicyCard.vue";
import PolicyService from "@/services/payroll/PolicyService";

@Component({
	components: { PTOPolicyCard }
})
export default class PTOViewCompany extends Vue {
	@Prop({ required: true })
	private companyId!: number;

	private policy: PTOPolicy | null = null;
	private loading = true;
	private RouteNames = RouteNames;

	public created() {
		this.load();
	}

	private load() {
		Application.startLoading();
		this.loading = true;
		const filter = new PTOPolicyFilter({
			companyId: this.companyId,
			isActive: true,
			pageSize: 1,
			pageNumber: 0
		});
		PolicyService.getPageOfPTOPolicies(filter)
			.then(res => {
				const data = res.data?.data;
				this.policy = data?.length ? data[0] : null;
				Application.stopLoading();
				this.loading = false;
			})
			.catch(err => {
				this.policy = null;
				this.loading = false;
				Application.stopLoading();
				processError(err, this);
			});
	}

	private toSignPage(publicId: string) {
		this.$router.push({ name: RouteNames.SIGN_PUBLIC, params: { publicId } });
	}

	private prettyEnum = prettyEnum;
}
